import PropTypes from 'prop-types';
import { Row, Col, Typography } from 'antd'
import Box from '../../components/utility/box';
import { ResponsiveBar } from '@nivo/bar';

const { Title } = Typography;

function MostPatientsBarCharts(props) {

  const getBarColor = barItem => barItem.data.color;

  return (
    <Box>
      <Row>
        <Col span={24}>
          <Title level={4} style={{ textAlign: "center" }}>
            {props.chartTitle}
          </Title>
          <ResponsiveBar
            data={props.data}
            keys={['patientsCount']}
            indexBy={props.indexBy}
            margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
            padding={0.3}
            valueScale={{ type: 'linear' }}
            indexScale={{ type: 'band', round: true }}
            colors={getBarColor}
            groupMode='grouped'
            defs={[
              {
                id: 'dots',
                type: 'patternDots',
                background: 'inherit',
                color: '#38bcb2',
                size: 4,
                padding: 1,
                stagger: true
              },
              {
                id: 'lines',
                type: 'patternLines',
                background: 'inherit',
                color: '#eed312',
                rotation: -45,
                lineWidth: 6,
                spacing: 10
              }
            ]}
            borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
            axisTop={null}
            axisRight={null}
            axisBottom={null}
            labelSkipWidth={12}
            labelSkipHeight={12}
            labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
            animate={true}
            motionStiffness={90}
            motionDamping={15}
            height={700}
            legends={[
              {
                dataFrom: 'indexes',
                anchor: 'top-right',
                direction: 'column',
                justify: false,
                translateX: 120,
                translateY: 0,
                itemsSpacing: 2,
                itemWidth: 180,
                itemHeight: 20,
                itemDirection: 'left-to-right',
                itemOpacity: 0.85,
                symbolSize: 20,
                effects: [
                  {
                    on: 'hover',
                    style: {
                      itemOpacity: 1,
                    }
                  }
                ]
              }
            ]}
          />
        </Col>
      </Row>
    </Box>
  );
}

MostPatientsBarCharts.propTypes = {
  data: PropTypes.array.isRequired,
  indexBy: PropTypes.string.isRequired,

  chartTitle: PropTypes.object.isRequired
};

MostPatientsBarCharts.defaultProps = {
  data: []
}

export default MostPatientsBarCharts;